export default "__VITE_ASSET__6265df30__"